module.exports = __webpack_public_path__ + "img/theme1.b254339f.png";